const radii = {
  sm: '5px',
  md: '8px',
};

export default radii;